import { render, staticRenderFns } from "./AddFavoritesRepair.vue?vue&type=template&id=1a505a6b&scoped=true&"
import script from "./AddFavoritesRepair.vue?vue&type=script&lang=js&"
export * from "./AddFavoritesRepair.vue?vue&type=script&lang=js&"
import style0 from "./AddFavoritesRepair.vue?vue&type=style&index=0&id=1a505a6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a505a6b",
  null
  
)

export default component.exports